import { Component, Input } from "@angular/core";
import { ItemInfoComponent } from "@ponder-shared/components/item-info.component";

@Component({
    selector: "magic-collection-info",
    imports: [],
    templateUrl: "./magic-collection-info.component.html"
})
export class MagicCollectionInfoComponent extends ItemInfoComponent {
    @Input({ required: true }) username!: string;
}